module.exports = __webpack_public_path__ + "img/新竹市.9d3d1ecb.png";